import { render, staticRenderFns } from "./ImportarJ4.vue?vue&type=template&id=66286e8c&scoped=true"
import script from "./ImportarJ4.vue?vue&type=script&lang=js"
export * from "./ImportarJ4.vue?vue&type=script&lang=js"
import style0 from "./ImportarJ4.vue?vue&type=style&index=0&id=66286e8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66286e8c",
  null
  
)

export default component.exports